import { GlassBox, H2 } from './ui';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

export const ErrorPage = ({ code, message }: { code: number, message: string }) => {
    return (
        <div
            style={{
                height: 'calc(100vh - 87px)',
                position: 'relative',
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.8)'
            }}>

            <Box sx={{
                backgroundImage: "url('/assets/error.webp')",
                color: '#f0f0f0', backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: 400,
                width: 400,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                borderRadius: 8,
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)'
            }}>
                <GlassBox opacity={0.1} sx={{ p: 3, textAlign: 'center' }}>
                    <Stack spacing={1} alignItems="center">
                        <H2>{code}</H2>
                        <p>{message}</p>
                        <Button variant="contained" color="primary" href="/">
                            Go to Home
                        </Button>
                    </Stack>
                </GlassBox>
            </Box>

        </div >
    );
};
